import request from '@/axios/http'


export function bannerApi (data) {
	return request({
		url: '/stage-api/lottery/banner/list',
		method: 'get',
		data
	})
}

export function help (data) {
	return request({
		// url: '/stage-api/help',
		url: '/stage-api/pre/center/list',
		method: 'get',
		data
	})
}
export function notice (data) {
	return request({
		url: '/stage-api/cms/pre_notice/notice_list',
		method: 'get',
		data
	})
}
export function queryPreRankingList (data) {
	return request({
		url: '/stage-api/pre/record/queryPreRankingList',
		method: 'post',
		data,
	})
}
